import { useState } from "react";
import { FileSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsFileProps = {
    settings: FileSettings
    onChange: (settings: FileSettings) => void;
}

export const AppCustomPropertySettingsFile = ({settings, onChange} : AppCustomPropertySettingsFileProps) => {
    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">

                <div className="app-custom-property-label">
                    Allow Multiple
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.allowMultiple}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                allowMultiple: checked
                            });
                        }}
                    />
                </div>
            </div>

        </div>
    )
}